/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleUp: {
  name: 'triangle-up';
  data: string;
} = {
  name: 'triangle-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.057 15H8.943a1 1 0 0 1-.814-1.581l3.057-4.28a1 1 0 0 1 1.628 0l3.056 4.28A1 1 0 0 1 15.057 15Z" fill="currentColor"/></svg>`,
};
